import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionNotificationModalComponent } from './session-notification-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AuthenticationService } from '@modules/authentication/authentication.service';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [SessionNotificationModalComponent],
  exports: [SessionNotificationModalComponent],
  imports: [CommonModule, MatDialogModule, TranslateModule, MatDividerModule],
  providers: [AuthenticationService],
})
export class SessionNotificationModalModule {}
